<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Individual Commission Summary</h3>
        <b-container>
            <b-row v-if="individual_summary">
                <b-col cols="12">
                    <b-row>
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-600">Generated On: &nbsp;</p>
                            <p class="font-weight-600">{{ individual_summary.created_at }}</p>
                        </b-col>
                    </b-row>
                    <template v-if="individual_summary.case_recognize && individual_summary.case_recognize.case">
                        <b-row>
                            <b-col cols="12" md="8" class="d-flex align-items-center">
                                <p class="font-weight-500">Case ID: &nbsp;</p>
                                <p>#{{ individual_summary.case_recognize.case.prod_id }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="8" class="d-flex align-items-center">
                                <p class="font-weight-500">Name: &nbsp;</p>
                                <router-link :to="'/customerProfileDetails/' + individual_summary.case_recognize.customer_id + '?active=overview'" class="text-primary" target="_blank">
                                    {{ individual_summary.case_recognize.case.prod_customer_name }}
                                </router-link>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="8" class="d-flex align-items-center">
                                <p class="font-weight-500">Project: &nbsp;</p>
                                <p>{{ individual_summary.case_recognize.case.prod_type }}</p>
                            </b-col>
                        </b-row>
                        <b-row v-if="individual_summary.case_recognize.case && individual_summary.case_recognize.case.prod_details">
                            <b-col cols="12" md="8" class="d-flex">
                                <p class="font-weight-500">Project Detail: &nbsp;</p>
                                <template>
                                    <div v-if="individual_summary.case_recognize.case.prod_type == 'property' || individual_summary.case_recognize.case.prod_type == 'mortgage'">
                                        <p>{{ individual_summary.case_recognize.case.prod_details.property_mortgage.prod_pm_project_name }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.property_mortgage.prod_pm_property_type }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.property_mortgage.prod_pm_lease_type }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.property_mortgage.prod_pm_unit_no }}</p>
                                    </div>
                                    <div v-else-if="individual_summary.case_recognize.case.prod_type == 'personal_loan'">
                                        <p>{{ individual_summary.case.prod_details.personal_loan.prod_pl_loan_agreement_rate }}</p>
                                    </div>
                                    <div v-else-if="individual_summary.case_recognize.case.prod_type == 'insurance'">
                                        <p>{{ individual_summary.case_recognize.case.prod_details.insurance.prod_ins_type }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.insurance.prod_ins_package }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.insurance.prod_ins_company }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.insurance.prod_ins_premium_pa }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.insurance.prod_ins_premium_pm }}</p>
                                        <p>{{ individual_summary.case_recognize.case.prod_details.insurance.prod_ins_premium_cover }}</p>
                                    </div>
                                </template>
                            </b-col>
                        </b-row>
                        <b-row v-if="individual_summary.case_recognize.use_user">
                            <b-col cols="12" md="8" class="d-flex align-items-center">
                                <p class="font-weight-500">IM2U Agent / SSA [SAS]: &nbsp;</p>
                                <p>{{ individual_summary.case_recognize.use_user.name }}</p>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row v-if="individual_summary.comms_payout_summary">
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-500">Client Net: &nbsp;</p>
                            <p>RM {{ individual_summary.comms_payout_summary.cps_develop_nett_price | moneyFormatter }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-500">Revenue Point: &nbsp;</p>
                            <p>RM {{ individual_summary.actual_total_revenue_point | moneyFormatter }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-500">Payout Level: &nbsp;</p>
                            <p>{{ individual_summary.payout_level_code }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-500">Payout Percentage(%): &nbsp;</p>
                            <p>{{ individual_summary.payout_percentage | moneyFormatter }}%</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-500">Commission Value: &nbsp;</p>
                            <p>RM {{ individual_summary.actual_payout_revenue_point | moneyFormatter }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8" class="d-flex align-items-center">
                            <p class="font-weight-500">Balance: &nbsp;</p>
                            <p>RM {{ 0 | moneyFormatter }}</p>
                        </b-col>
                    </b-row>

                    <div class="table-listings">
                        <b-table-simple responsive bordered>
                            <b-thead>
                                <b-tr variant="primary">
                                    <b-th>Date</b-th>
                                    <b-th>Particulars</b-th>
                                    <b-th>OR / PV No (%)</b-th>
                                    <b-th>Credit In</b-th>
                                    <b-th>Credit Out</b-th>
                                    <b-th>Balance</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(item, index) in tableData" :key="index">
                                    <b-td>{{ item.date }}</b-td>
                                    <b-td>{{ item.particulars }}</b-td>
                                    <b-td class="text-right">{{ item.or_pv_percent || '0.0' }}</b-td>
                                    <b-td class="text-right">{{ item.credit_in | moneyFormatter }}</b-td>
                                    <b-td class="text-right">{{ item.credit_out | moneyFormatter }}</b-td>
                                    <b-td class="text-right">{{ item.balance | moneyFormatter }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"

export default {
    props: {
        show_individual_summary: Boolean,
        individual_summary: Object
    },
    components: {
        Modal,
    },
    data() {
        return {
            tableData: [
                {
                    date: '30-6-2023',
                    particulars: 'Commission',
                    or_pv_percent: 0,
                    credit_in: 3895.50,
                    credit_out: 0,
                    balance: 3895.50,
                }
            ]
        }
    },
    computed: {
        show: {
            get() {
                return this.show_individual_summary;
            },
            set(newVal) {
                this.$emit('update:show_individual_summary', newVal);
                console.log(this.individual_summary);
            },
        },
    },
}
</script>